import React, { useState } from "react";
import Footer from "./Footer";
import "../css/shop.scss";
import { Link } from "react-router-dom";
import productData from "../Datas/productData";
import Header from "./Header";

function Shop() {
  const [wishlist, setWishlist] = useState([]);

  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const toggleWishlist = (productId) => {
    if (wishlist.includes(productId)) {
      setWishlist(wishlist.filter((id) => id !== productId));
    } else {
      setWishlist([...wishlist, productId]);
    }
  };

  return (
    <body className="color-scheme color-scheme--scheme-1">
      <Header />

      <main className="shop-page">
        {/* Hero Section */}
        <section className="shop-hero">
          <div className="shop-hero__content">
            <h1 className="shop-hero__title">Best Sellers</h1>
            <p className="shop-hero__subtitle">
              Discover our selection of best-selling products.
            </p>
          </div>
        </section>

        {/* Breadcrumb */}
        <div className="shop-breadcrumb">
          <div className="shop-breadcrumb__container">
            <Link to="/" className="shop-breadcrumb__link">
              Home
            </Link>
            <span className="shop-breadcrumb__separator">/</span>
            <span className="shop-breadcrumb__current">Best Sellers</span>
          </div>
        </div>

        {/* Main Content */}
        <div className="shop-content">
          <div className="shop-content__container">
            {/* Products Grid */}
            <div className="shop-products">
              <div className="shop-products__grid">
                {productData.map((product) => (
                  <div key={product.id} className="product-card">
                    <div className="product-card__image-wrapper">
                      <Link to={`/shopDetails/${product.id}`} onClick={toTop}>
                        <img
                          src={product.images[0]}
                          alt={product.name}
                          className="product-card__image"
                        />
                      </Link>
                      <div className="product-card__badge">
                        <svg
                          width="60"
                          height="60"
                          viewBox="0 0 60 60"
                          fill="none"
                        >
                          <circle
                            cx="30"
                            cy="30"
                            r="28"
                            fill="white"
                            stroke="#2c3e50"
                            strokeWidth="1"
                          />
                          <text
                            x="30"
                            y="22"
                            fontSize="8"
                            textAnchor="middle"
                            fill="#2c3e50"
                            fontWeight="600"
                          >
                            BEST
                          </text>
                          <text
                            x="30"
                            y="32"
                            fontSize="8"
                            textAnchor="middle"
                            fill="#2c3e50"
                            fontWeight="600"
                          >
                            SELLER
                          </text>
                          <path
                            d="M15 38 L20 35 L25 38 L30 35 L35 38 L40 35 L45 38"
                            stroke="#2c3e50"
                            strokeWidth="1"
                            fill="none"
                          />
                        </svg>
                      </div>
                      <button
                        className={`product-card__wishlist ${
                          wishlist.includes(product.id) ? "active" : ""
                        }`}
                        onClick={() => toggleWishlist(product.id)}
                        aria-label="Add to wishlist"
                      >
                        <i
                          className={`${
                            wishlist.includes(product.id) ? "fas" : "far"
                          } fa-heart`}
                        ></i>
                      </button>
                    </div>
                    <div className="product-card__info">
                      <p className="product-card__brand">{product.country}</p>
                      <Link to={`/shopDetails/${product.id}`} onClick={toTop}>
                        <h3 className="product-card__name">{product.name}</h3>
                      </Link>
                      <p className="product-card__price">${product.price}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </body>
  );
}

export default Shop;
